const c = "card_name", _ = "card_number", C = "card_cvc", r = "card_expirationDate", t = "/vgs/encrypt-credit-card";
export {
  C as CC_CVC_ID,
  r as CC_EXPIRATION_ID,
  c as CC_NAME_ID,
  _ as CC_NUMBER_ID,
  t as VGS_ACTION_ENDPOINT
};
